{
  "Brand": "Merk",
  "sales-articles": {
    "safe-use-labels": {
      "KeepAwayFromChildren":  "Buiten bereik van kinderen bewaren.",
      "RinseHandsAfterUse":  "Na gebruik de handen afspoelen.",
      "DoNotIngest":  "Niet inslikken. In geval van inslikken een arts raadplegen.",
      "DoNotMix":  "Niet mengen met andere producten.",
      "KeepAwayFromEyes":  "Oogcontact vermijden. Bij oogcontact grondig uitspoelen met water.",
      "AvoidIfSensitiveSkin": "Bij een gevoelige of beschadigde huid langdurig contact vermijden. ",
      "DoNotChangeContainer": "Het product in de oorspronkelijke verpakking bewaren.",
      "Ventilate": "Na gebruik de ruimte ventileren.",
      "UseWithDryHands":  "Met droge handen gebruiken.",
      "CloseBagProperly": "Zak goed sluiten.",
      "CloseLidProperly": "Deksel goed sluiten.",
      "DoNotPierce": "Niet snijden, knippen of doorboren.",
      "icons": {
        "KeepAwayFromChildren": "keep-away-from-children.webp",
        "RinseHandsAfterUse":  "rinse-hands-after-use.webp",
        "DoNotIngest":  "do-not-ingest.webp",
        "DoNotMix":  "do-not-mix.webp",
        "KeepAwayFromEyes":  "keep-away-from-eyes.webp",
        "AvoidIfSensitiveSkin": "avoid-if-sensitive-skin.webp",
        "DoNotChangeContainer": "do-not-change-container.webp",
        "Ventilate": "ventilate.webp",
        "UseWithDryHands":  "use-with-dry-hands.webp",
        "CloseBagProperly": "close-bag-properly.webp",
        "CloseLidProperly": "close-lid-properly.webp",
        "DoNotPierce": "do-not-pierce.webp"
      }
    },
    "dangerous-content-labels": {
      "GasUnderPressure": "Gassen onder druk.",
      "Explosive": "Explosiegevaar.",
      "Oxidising": "Kan een allergische huidreactie of ernstige oogirritatie veroorzaken.",
      "Flammable": "Hoog- of zeer licht ontvlambaar gas, aerosol, vloeistof of damp",
      "Corrosive": "Kan ernstige brandwonden en oogletsel veroorzaken.",
      "HealthHazard": "Gezondheidsgevaar.",
      "AcuteToxicity": "Acute toxiciteit.",
      "SeriousHealthHazard": "Ernstig gezondheidsgevaar.",
      "HazardousToTheEnvironment": "Giftig voor het milieu.",
      "icons": {
        "GasUnderPressure": "gass-under-pressure.webp",
        "Explosive": "explosive.webp",
        "Oxidising": "oxidising.webp",
        "Flammable": "flammable.webp",
        "Corrosive": "corrosive.webp",
        "HealthHazard": "health-hazard.webp",
        "AcuteToxicity": "acute-toxicity.webp",
        "SeriousHealthHazard": "serious-health-hazard.webp",
        "HazardousToTheEnvironment": "hazardous-to-the-environment.webp"
      }
    }
  }
}
